import React from 'react';
import { Receipt } from 'lucide-react';
import { TabSales } from './Reports';

// Standalone page for the sales report (surfaced in the sidebar under Reports).
export default function SalesReport() {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <Receipt size={22} className="text-orange-500" />
        <div>
          <h1 className="text-xl font-bold text-gray-800">Sales</h1>
          <p className="text-xs text-gray-400">What you invoiced, net of credit notes — the accountant's sales figure</p>
        </div>
      </div>
      <TabSales />
    </div>
  );
}
